"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-w6i1nn5"
});
const ItemText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ItemText",
  class: "pl-i1aznq26"
});
const ItemList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "ItemList",
  class: "pl-iyflik",
  vars: {
    "iyflik-0": [({
      open
    }) => open ? '100vh' : '0']
  }
});
const IconChevronDown = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconChevronDown",
  class: "pl-i1te0d9",
  vars: {
    "i1te0d9-1": [({
      open
    }) => open ? 'rotate(-180deg)' : 'none']
  }
});
function NestedNavItem({
  children,
  itemText
}) {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const keydownRef = (0, _react.useRef)(false);
  const handleClick = () => {
    if (!keydownRef.current) {
      setIsOpen(prev => !prev);
    }
  };
  const handleFocus = () => {
    keydownRef.current = true;
    setIsOpen(true);
  };
  const handleMouseDown = () => {
    keydownRef.current = false;
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(ItemText, {
    "data-cy": "nested-item-text",
    onClick: handleClick,
    onFocus: handleFocus,
    onMouseDown: handleMouseDown,
    tabIndex: 0
  }, itemText, children && /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    open: isOpen
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  }))), /*#__PURE__*/_react.default.createElement(ItemList, {
    open: isOpen
  }, children));
}
var _default = exports.default = NestedNavItem;
NestedNavItem.propTypes = {
  itemText: _propTypes.default.string,
  children: _propTypes.default.node
};